import type { IconType } from "react-icons";
import type { ElementType, FC, ReactNode } from "react";
import { HStack, StackProps, Text } from "@chakra-ui/react";

import { LeadingIcon } from "../../leading-icon";
import { SectionHeaderMobile } from "./section-header-mobile";

import { type InferProps } from "@shared/types/misc";

interface Props {
  icon: ElementType;
  title: string;
  helperText?: any;
  rightContent?: ReactNode;
  /** Mobile version of the section header appear only when this prop passed */
  smScreenSettings?: {
    icon: IconType;
    title: string;
    actions: ReactNode;
  };

  leadingIconProps?: Partial<InferProps<typeof LeadingIcon>>;
  containerProps?: Partial<StackProps>;
  textProps?: Partial<InferProps<typeof Text>>;
}

export const SectionHeader: FC<Props> = ({
  icon,
  title,
  textProps,
  helperText,
  rightContent,
  containerProps,
  leadingIconProps,
  smScreenSettings,
}) => {
  return (
    <HStack
      w="full"
      alignItems="center"
      justifyContent="space-between"
      {...containerProps}
    >
      <HStack
        w="full"
        display={smScreenSettings ? { base: "none", md: "flex" } : "flex"}
      >
        <HStack alignItems="center" gap={2} w="full">
          <LeadingIcon icon={icon} {...leadingIconProps} />
          <Text
            textWrap="nowrap"
            w="fit-content"
            fontSize={{ base: "sm", md: "xl", xl: "xl" }}
            {...textProps}
          >
            {title}
          </Text>
          <Text color="gray.500" mx={2} fontSize="sm">
            {helperText}
          </Text>
        </HStack>

        <HStack w="full" justifyContent="flex-end">
          {rightContent && <HStack>{rightContent}</HStack>}
        </HStack>
      </HStack>

      {smScreenSettings && (
        <HStack
          p={2}
          w="full"
          justifyContent="center"
          display={{ base: "flex", md: "none" }}
        >
          <SectionHeaderMobile {...smScreenSettings} />
        </HStack>
      )}
    </HStack>
  );
};
